export enum AuditActionType {
  UPDATE = 'Update',
  INSERT = 'Insert',
  DELETE = 'Delete',
}
